import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
  isAccountAppHost,
} from "../lib/auth/app-origins";

/** OAuth callback now lives on account-web — bounce any leftover pro callbacks. */
export const Route = createFileRoute("/auth/google/callback")({
  beforeLoad: () => {
    if (typeof window === "undefined") return;
    // Already on account-web (e.g. localhost:5174): never bounce+halt to the
    // same URL — that permanently hangs the router (black screen).
    if (isAccountAppHost()) return;
    bounceToAccountPath("/auth/google/callback", window.location.search);
    haltForExternalNavigation();
  },
  validateSearch: (search: Record<string, unknown>) => ({
    code: (search.code as string) || undefined,
    error: (search.error as string) || undefined,
  }),
  component: () => null,
});
